import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CampaignAddressEdit } from '@/pages';

const searchSchema = z.object({
  addressId: z.coerce.number().int().positive().optional(),
});

export const Route = createFileRoute('/_authenticated/campaign/$id/address-edit')({
  validateSearch: searchSchema,
  component: CampaignAddressEdit,
});
